import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const propTypes = {
  isOpen: PropTypes.bool,
  headerClassName: PropTypes.string,
  modalBody: PropTypes.node.isRequired,
  modalHeader: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  modalSize: PropTypes.oneOf(["sm", "lg", "xl"]),
  toggleModal: PropTypes.func.isRequired
};

const CommonModal = ({
  headerClassName = "",
  isOpen = false,
  modalBody,
  modalHeader = null,
  modalSize = null,
  toggleModal
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size={modalSize}>
      <ModalHeader toggle={toggleModal} className={headerClassName}>
        {modalHeader}
      </ModalHeader>
      <ModalBody className="p-4">{modalBody}</ModalBody>
    </Modal>
  );
};

CommonModal.propTypes = propTypes;

export default CommonModal;
